import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CustomFormProps } from ".";
import { setGlobalPopupElement } from "../../features/popupSlice";
import { ImageContainerEditButton } from "../components";
import FormInputItem from "../FormInputItem";
import ImagePopUpV2 from "../ImagePopUpV2";
import { SettingItem } from "../SettingFormItems";
import LinkForm, { LinkData } from "../widgetFrom/LinkForm";
import classes from "./CWForm.module.css";

export const objectKeys = Object.keys as <T>(o: T) => (keyof T)[];

const linkData = {
  hyperLinkText: "",
  url: "",
  urlType: "category",
};

type SettingsNames =
  | "isSlider"
  | "width"
  | "height"
  | "objectFit"
  | "col"
  | "autoplay"
  | "delay"
  | "gap";

const bannerSettings: SettingItem<SettingsNames>[] = [
  {
    name: "Is Slider",
    key: "isSlider",
    type: "checkbox",
  },
];

const NewsScrollerForm = ({
  formItems,
  customForm = false,
  name = "",
  onSubmit = () => {},
  title,
  className,
  style,
}: CustomFormProps) => {
  const dispatch = useDispatch();

  const [news, setNews] = useState<
    { id: number; value: string; logo?: string; link?: LinkData }[]
  >((formItems as any)?.news || []);

  const [isSlider, setIsSlider] = useState(
    (formItems as any)?.isSlider || false
  );

  const [slideDuration, setSlideDuration] = useState(
    (formItems as any)?.slideDuration || false
  );

  useEffect(() => {
    if (news.length === 0)
      setNews([{ id: Date.now(), value: "", link: linkData }]);
  }, [news]);

  const classNames = [classes.CWForm, className];

  const handleSubmit = () => {
    onSubmit({
      ...formItems,
      news: news,
      isSlider,
      slideDuration,
    } as any);
  };

  const handleImageSelector = (index: number) => {
    dispatch(
      setGlobalPopupElement(
        <ImagePopUpV2
          single={true}
          onUpdate={(images) => {
            const arrayImages = images.map((item: any) => {
              return {
                image: item.path,
                title: item.title,
                link: {} as LinkData,
              };
            });

            // setImages(arrayImages)
            const item = arrayImages[0];

            setNews((prev) => {
              const newNews = [...prev];
              newNews[index] = {
                ...newNews[index],
                logo: item.image,
              };

              return newNews;
            });

            dispatch(setGlobalPopupElement(null));
          }}
          onClose={() => {
            dispatch(setGlobalPopupElement(null));
          }}
        />
      )
    );
  };

  const handleLogoDelete = (index: number) => {
    dispatch(setGlobalPopupElement(
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-4 rounded-md flex flex-col gap-3">
      <p className="mb-5">Are you sure you want to delete this logo?</p>
      <div className="flex justify-center gap-10">
      <button
        className="text-white bg-gray-500 hover:bg-gray-600 px-4 py-2 rounded-md"
        onClick={() => dispatch(setGlobalPopupElement(null))}
      >
        No
      </button>
      <button
        className="text-white bg-red-500 hover:bg-red-600 px-4 py-2 rounded-md"
        onClick={() => {
          setNews((prev) => {
            const newNews = [...prev];
            newNews[index] = {
              ...newNews[index],
              logo: "",
            };

            return newNews;
          });
          dispatch(setGlobalPopupElement(null));
        }}
      >
        Yes
      </button>
      </div>
    </div>));

  };

  return (
    <div className={classNames.join(" ")} style={style}>
      <form className="mainSliderForm__container">
        <h1 className="title capitalize">{title}</h1>

        <div className="mainSliderForm__inputContainer">
          {/* <label className="mainSliderForm__label">Offer Banner</label> */}
          <div className="mainSliderForm__input">
            <div className="flex flex-col gap-2">
              <FormInputItem
                label={"Is Slider"}
                value={isSlider}
                type="checkbox"
                onChange={(value) => {
                  setIsSlider(value);
                }}
              />
              <FormInputItem
                label="Slide Duration in Second"
                value={slideDuration}
                placeholder="5"
                type="number"
                onChange={(value) => {
                  setSlideDuration(value);
                }}
              />
            </div>
            {news?.map((item, index) => (
              <div
                key={item.id}
                className="border-t border-gray-400 pt-3 first:border-none"
              >
                <div className="flex gap-3 mb-3">
                  <input
                    type="text"
                    placeholder="Enter Text"
                    value={item.value || ""}
                    onChange={(e) => {
                      setNews((prev) => {
                        const temp = [...prev];
                        temp[index] = {
                          ...temp[index],
                          value: e.target.value,
                        };
                        return temp;
                      });
                    }}
                  />

                  {/* remove button with inline tailwind */}
                  <button
                    disabled={news.length <= 1}
                    onClick={(e) => {
                      e.preventDefault();
                      setNews((prev) => prev.filter((_, i) => i !== index));
                    }}
                    className="w-14 text-2xl disabled:bg-gray-300 disabled:border-none disabled:text-white disabled:cursor-not-allowed text-red-500 hover:text-white border border-red-300 hover:bg-red-300 rounded-md"
                  >
                    {/* Trash icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mx-auto"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="flex items-center justify-between py-2 gap-4 w-[200px] h-[60px]">
                  <div className="capitalize tracking-wide">Logo:</div>
                  <ImageContainerEditButton
                    index={index}
                    imageUrl={
                      item.logo
                        ? process.env.REACT_APP_IMAGE_URL + item.logo
                        : "/placeholder.png"
                    }
                    handleImageSelector={() => handleImageSelector(index)}
                  />
                  <button type="button" className="text-red-500 hover:text-white border border-red-300 hover:bg-red-300 rounded-md px-2"
                  onClick={() => handleLogoDelete(index)}
                  >
                    Delete
                  </button>
                </div>

                <LinkForm
                  currnetLinkData={
                    (formItems as any)?.news?.[index]?.link || linkData
                  }
                  onUpdate={(data) => {
                    setNews((prev) => {
                      const temp = [...prev];
                      temp[index] = {
                        ...temp[index],
                        link: data,
                      };
                      return temp;
                    });
                  }}
                />
              </div>
            ))}
          </div>

          {/* add new button */}
          <div className="mainSliderForm__addNewBtnContainer">
            <button
              onClick={(e) => {
                e.preventDefault();
                setNews((prev) => [...prev, { id: Date.now(), value: "" }]);
              }}
              className="w-full p-2 py-1 text-2xl text-blue-500 hover:text-white border border-blue-300 hover:bg-blue-300 rounded-full"
            >
              +
            </button>
          </div>
        </div>

        <div>
          <button
            onClick={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            className="mainSliderForm__btn"
          >
            save
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewsScrollerForm;
